import { useMutation, useQuery } from "@tanstack/react-query";
import * as chatbotApi from "src/api/chatbot";
import type { ChatbotConversation } from "src/components/GlobalChatbot/types";
import { chatbotQueryKeys } from "src/hooks/chatbotQueryKeys";
import defaultOptions from "src/hooks/defaultOptions";
import { queryClient } from "src/queryClient";

export function useChatbotConversations() {
	return useQuery<ChatbotConversation[]>({
		queryKey: chatbotQueryKeys.conversations,
		queryFn: chatbotApi.getConversations,
		...defaultOptions,
		staleTime: 60 * 1000,
	});
}

export function useDeleteChatbotConversation() {
	return useMutation<void, unknown, string>({
		mutationFn: (conversationId) =>
			chatbotApi.deleteConversation(conversationId),
		onSuccess: (_data, conversationId) => {
			queryClient.setQueryData<ChatbotConversation[]>(
				chatbotQueryKeys.conversations,
				(prev) => (prev ?? []).filter((c) => c.id !== conversationId),
			);
		},
	});
}
